import React, {Component} from 'react';
import PropTypes from 'prop-types';
import DownloadPdfButton from "../components/Favourites/DownloadPdfButton";

export class GeneratePdfItineraryApp extends Component {

    static propTypes = {
        downloadLink: PropTypes.string,
        itineraryUid: PropTypes.number,
        fileName: PropTypes.string,
        downloadLinkTextOnly: PropTypes.string,
        downloadLinkAgency: PropTypes.string,
        type: PropTypes.string
    };

    render() {
        const {downloadLink, fileName, downloadLinkTextOnly, downloadLinkAgency, type} = this.props;

        return (
            <div>
                <div className='generatePdfContainer'>
                    <DownloadPdfButton downloadLink={downloadLink} downloadLinkTextOnly={downloadLinkTextOnly} downloadLinkAgency={downloadLinkAgency} fileName={fileName} type={type} />
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/apps/GeneratePdfItineraryApp.js